import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const FaceShape = lazyWithPreload(() => import('./FaceShape'))
